// extracted by mini-css-extract-plugin
export default {"topic":"Enriched_topic__sbvfG"};